import { createSelector } from 'reselect';
import { getUserAddedManualPartCounts } from './getUserAddedManualPartCounts';

export const getFirstUserAddedManualPartCountsPartTime = createSelector(
  [getUserAddedManualPartCounts],
  (userAddedManualPartCounts) => {
    return userAddedManualPartCounts?.[0]?.partTime;
  }
);
